import { useState } from "react";
import type { SidebarSection } from "./nav-items";

/**
 * The last children a row showed, so it can fold after they drop. Whether it
 * is open is the list's decision (`row.expanded`).
 */
export const useRowExpanded = (row: SidebarSection) => {
  const [kept, setKept] = useState(row.children);
  if (row.children && row.children !== kept) setKept(row.children);
  return {
    open: !!row.expanded,
    children: row.children ?? kept ?? [],
  };
};

/** A collapsed row still marks where the reader is. */
export const rowShowsActive = (row: SidebarSection, open: boolean) =>
  row.isActive ||
  (!open && !!row.children?.some((child) => child.isActive)) ||
  (!open && !!row.action?.isActive);
